// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var BigJs = require("big.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Ordering = require("relude/src/Relude_Ordering.bs.js");
var Relude_Extensions_Ord = require("relude/src/extensions/Relude_Extensions_Ord.bs.js");

function toFloat(prim) {
  return prim.toNumber();
}

function add(prim, prim$1) {
  return prim.plus(prim$1);
}

function fromInt(param) {
  return Relude_Globals.$great$great(Relude_Int.toFloat, (function (prim) {
                return new BigJs.Big(prim);
              }), param);
}

function sub(prim, prim$1) {
  return prim.minus(prim$1);
}

function mul(prim, prim$1) {
  return prim.times(prim$1);
}

function div(prim, prim$1) {
  return prim.div(prim$1);
}

function round(i, f) {
  return f.round(i);
}

function roundDown(i, f) {
  return f.round(i, 0);
}

function eq(prim, prim$1) {
  return prim.eq(prim$1);
}

function compare(a, b) {
  return Relude_Ordering.fromInt(a.cmp(b));
}

var Ord = {
  compare: compare,
  eq: eq
};

var include = Relude_Extensions_Ord.OrdExtensions({
      eq: eq,
      compare: compare
    });

var $plus$dot$dot = add;

var $neg$dot$dot = sub;

var $star$dot$dot = mul;

var $slash$dot$dot = div;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

exports.toFloat = toFloat;
exports.add = add;
exports.$plus$dot$dot = $plus$dot$dot;
exports.fromInt = fromInt;
exports.sub = sub;
exports.$neg$dot$dot = $neg$dot$dot;
exports.mul = mul;
exports.$star$dot$dot = $star$dot$dot;
exports.div = div;
exports.$slash$dot$dot = $slash$dot$dot;
exports.round = round;
exports.roundDown = roundDown;
exports.eq = eq;
exports.compare = compare;
exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
/* include Not a pure module */
